// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"a61b90fa","787":"cfc6ed2d","896":"52e79d4f"}[chunkId] + ".chunk.js";
};